import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "material-ui"
    }}>{`Material UI`}</h1>
    <p>{`Reforml provides binding to `}<a parentName="p" {...{
        "href": "https://material-ui.com/"
      }}>{`Material-UI`}</a></p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm i @reforml/material-ui
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`// import { MaterialBaseComponents, MaterialFieldComponents } from '@reforml/material-ui'
() => {
  const [value, setValue] = useState({})
  const handleChange = (newValue) => {
    setValue(newValue)
  }
  const fields = useMemo(() => jsyaml.load(\`
  myText:
    type: text
    label: Input some value
    fullWidth: true
    helperText: hello world
  myOption:
    type: select
    label: Input some value
    fullWidth: true
    options:
      - option1
      - option2
    helperText: hello world
  myCheckbox:
    type: checkbox
    label: check me
    helperText: hello world
  \`), [])
  return (
    <div>
      <ReformlProvider baseComponents={MaterialBaseComponents} fieldComponents={MaterialFieldComponents}>
        <BaseForm fields={fields} value={value} onChange={handleChange}/>
      </ReformlProvider>
      value:
      <pre>{JSON.stringify(value, null, 2)}</pre>
    </div>
  )
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      